import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function useAppPromotionTheme(isLightMode) {
  const location = useLocation()
  const isAppPromotion = location.pathname.startsWith("/app-promotion")

  useEffect(() => {
    if (!isAppPromotion) return

    const theme = isLightMode ? "light" : "dark"

    document.documentElement.dataset.theme = theme
    localStorage.setItem("theme", theme)
  }, [isAppPromotion, isLightMode])

  return isAppPromotion
}
